import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { languages } from '../i18n';

export default function LanguageSwitcher({ style = {}, dark = false }) {
  const { lang, changeLang } = useLanguage();

  const containerStyle = dark
    ? {
        display: 'inline-flex',
        background: 'rgba(255,255,255,0.07)',
        borderRadius: '8px',
        padding: '3px',
        gap: '1px',
        border: '1px solid rgba(255,255,255,0.10)',
        ...style,
      }
    : { display: 'flex', gap: '4px', ...style };

  return (
    <div style={containerStyle}>
      {Object.values(languages).map((l) => (
        <button
          key={l.lang}
          onClick={() => changeLang(l.lang)}
          title={l.langName}
          style={{
            padding: dark ? '4px 10px' : '3px 8px',
            borderRadius: '6px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '0.68rem',
            fontWeight: '700',
            letterSpacing: dark ? '0.05em' : '0.03em',
            background: dark
              ? (lang === l.lang ? 'rgba(255,255,255,0.15)' : 'transparent')
              : (lang === l.lang ? '#002147' : 'transparent'),
            color: dark
              ? (lang === l.lang ? '#ffffff' : 'rgba(255,255,255,0.42)')
              : (lang === l.lang ? 'white' : '#9ca3af'),
            transition: 'all 0.15s ease',
            boxShadow: dark && lang === l.lang ? '0 1px 2px rgba(0,0,0,0.25)' : 'none',
          }}
        >
          {l.langLabel}
        </button>
      ))}
    </div>
  );
}
